import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import SearchIcon from '@mui/icons-material/Search';
import { DateAndTimeFields, DeviceStateCheckboxes } from '../../Helpers/filterHelper';

const Filter = ({ filters, setFilters, onSearch, deviceStateFilters = true, dateRanges=true, labelMapper}) => {


  const handleCheckboxChange = (stateKey) => (event) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      deviceStates: {
        ...prevFilters.deviceStates,
        [stateKey]: event.target.checked,
      },
    }));
  };

  const handleSearchClick = () => {
    onSearch();
  };

  return (
    <Card sx={{ p: 2 }}>
      <Grid container rowSpacing={2} columnSpacing={2}>
        {deviceStateFilters && (
          <Grid item xs={12}>
            <DeviceStateCheckboxes
              deviceStates={filters.deviceStates}
              onChange={handleCheckboxChange}
              mapper={labelMapper}
            />
          </Grid>
        )}

        {dateRanges && (
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <DateAndTimeFields
                label="Από"
                dateValue={filters.fromDate}
                timeValue={filters.fromTime}
                onDateChange={(val) => setFilters((prev) => ({ ...prev, fromDate: val }))}
                onTimeChange={(val) => setFilters((prev) => ({ ...prev, fromTime: val }))}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <DateAndTimeFields
                label="Έως"
                dateValue={filters.toDate}
                timeValue={filters.toTime}
                onDateChange={(val) => setFilters((prev) => ({ ...prev, toDate: val }))}
                onTimeChange={(val) => setFilters((prev) => ({ ...prev, toTime: val }))}
              />
            </Grid>
          </Grid>
        </Grid>
      )}

        <Grid item xs={12}>
      <Button
        variant="contained"
        startIcon={<SearchIcon />}
        sx={{ mt: 2 }}
        onClick={handleSearchClick}
      >
        Αναζήτηση
      </Button>
    </Grid>
      </Grid>
    </Card>
  );
};

export default Filter;